import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useUpdateLaborMutation } from "../../../Services/inventory/Inventory";
import useThemeColors from "../../vehicle/ThemeColors";
import { useGetAllServiceDataQuery, useGetSubServiceOnIdBasisDataQuery } from "../../../Services/vehicle/Vehicle";

interface IPROPS {
    closeModal: any;
    refetch: any;
    storeValue: any;
}

const EditLabor: React.FC<IPROPS> = ({ closeModal, refetch, storeValue }) => {

    console.log(storeValue, "storeValue")
    const [laborId, setLaborId] = useState(storeValue?.labour_id);
    const [subServiceName, setSubServicename] = useState(
        storeValue?.sub_service_name
    );
    const [subServiceTableData, setSubServiceTableData] = useState([]);
    const [serviceTableData, setServiceTableData] = useState([]);
    
            const [serviceTypeId, setServiceTypeId] = useState<any>(storeValue?.service_name)
                    const [subServiceTypeId, setSubServiceTypeId] = useState<any>(storeValue?.sub_service_name)
            
    

    // const [serviceName, setServicename] = useState(
    //     storeValue?.service_name_display
    // );
    const [time, setTime] = useState(storeValue?.test_time);
    const [cost, setCost] = useState(storeValue?.default_rate);

    const [updateLaborTrigger] = useUpdateLaborMutation();

    const { data: subServiceData } =
        useGetSubServiceOnIdBasisDataQuery(serviceTypeId);

                    const {
                                                            data: serviceData,
                                                      
                                                        } = useGetAllServiceDataQuery({});

    useEffect(() => {
        if (subServiceData) {
            setSubServiceTableData(subServiceData);
        }
    }, [subServiceData]);

     useEffect(() => {
                                                        if (serviceData) {
                                                            setServiceTableData(serviceData?.results);
                                                        }
                                                    }, [serviceData]);

    const saveHandler = async (e) => {
        e.preventDefault();
        const laborEditPayload = {
            labour_id: laborId,
            service_name: serviceTypeId,
            "sub_service_type": subServiceTypeId,
            test_time: time,
            default_rate: cost,
        };

        const response = await updateLaborTrigger(laborEditPayload);

        try {
            if (response?.data) {
                toast.success("Edited successfully");
                refetch();
                closeModal();
            } else if (response?.error) {
                toast.error("An error occurred");
            }
        } catch (error) {
            console.log(error);
        }
        console.log(response, "responsee");
    };

    const {
        selectedColor,
        selectedBackgroundColor,
        selectedBorderColor,
        selectedButtonBackgoundColors,
        selectedButtonColors,
    } = useThemeColors();
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div>
                <label>Labor id</label>
                <input
                    className="form-control form-control-solid"
                    type="text"
                    disabled
                    value={laborId}
                />
            </div>
            {/* <div>
                <label>Service name</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setServicename(e.target.value)}
                    value={serviceName}
                />
            </div> */}

               <div style={{ width: "100%" }}>
                            <p
                                className="vehicle-class"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <span
                                    className="required"
                                    style={{
                                        paddingLeft: "10px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    Service type
                                </span>
                                <span>


                                    <select
                                    value={serviceTypeId}
                                        onChange={(e) =>
                                            setServiceTypeId(e.target.value)
                                        }
                                        style={{
                                            background: "#FCFCFC",
                                            width: "100%",
                                            borderRadius: "30px",
                                            padding: "12px",
                                        }}
                                    >
                                      <option>Select an option</option>

                                      {serviceTableData?.map((service, index) => (

                                        <option value={service?.id}>{service?.name}</option>
                                    
                                      ))}

                                    </select>
                                </span>
                            </p>
                        </div>
            <div style={{ width: "100%" }}>
                <p
                    className="vehicle-class"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <span
                        className="required"
                        style={{
                            paddingLeft: "10px",
                            marginBottom: "10px",
                        }}
                    >
                        Sub service
                    </span>
                    <span>
                        <select
                            value={subServiceTypeId}
                            onChange={(e) =>
                                setSubServiceTypeId(e.target.value)
                            }
                            style={{
                                background: "#FCFCFC",
                                width: "100%",
                                borderRadius: "30px",
                                padding: "12px",
                            }}
                        >
                            <option>Select an option</option>
                            {subServiceTableData?.map((subService, index) => (
                                <option value={subService?.name}>
                                    {subService?.name}
                                </option>
                            ))}
                        </select>
                    </span>
                </p>
            </div>
            <div>
                <label>Service time</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setTime(e.target.value)}
                    value={time}
                    type="time"
                />
            </div>
            <div>
                <label>Cost</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setCost(e.target.value)}
                    value={cost}
                />
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                }}
            >
                <button
                    className="btn btn-secondary"
                    onClick={closeModal}
                    style={{ borderRadius: "20px" }}
                >
                    Cancel
                </button>
                <button
                    style={{
                        background: `${selectedButtonBackgoundColors}`,
                        color: `${selectedButtonColors}`,
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "20px",
                        fontSize: "15px",
                    }}
                    onClick={saveHandler}
                >
                    {" "}
                    Save
                </button>
            </div>
        </div>
    );
};

export default EditLabor;
